import { render, staticRenderFns } from "./Receptions.vue?vue&type=template&id=bc677a00&scoped=true"
import script from "./Receptions.vue?vue&type=script&lang=js"
export * from "./Receptions.vue?vue&type=script&lang=js"
import style0 from "./Receptions.vue?vue&type=style&index=0&id=bc677a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc677a00",
  null
  
)

export default component.exports